import React from 'react';
import { Search } from 'lucide-react';

interface SidebarFilterProps {
    title: string;
    categories: { name: string; count?: number; active?: boolean; onClick?: () => void }[];
    onSearch: (query: string) => void;
}

const SidebarFilter: React.FC<SidebarFilterProps> = ({ title, categories, onSearch }) => {
    return (
        <div className="space-y-8">
            {/* Search Box */}
            <div className="bg-white p-6 rounded-lg shadow-sm border">
                <h3 className="font-bold text-gray-800 mb-4 border-b pb-2">Hızlı Arama</h3>
                <div className="relative">
                    <input 
                        type="text" 
                        placeholder="Hızlı Ürün Arama" 
                        className="w-full pl-3 pr-10 py-2 border rounded focus:outline-none focus:border-blue-500 text-sm"
                        onChange={(e) => onSearch(e.target.value)}
                    />
                    <button className="absolute right-0 top-0 h-full px-3 text-white bg-[#333] rounded-r hover:bg-black transition-colors">
                        <Search size={16} />
                    </button>
                </div>
            </div>

            {/* Categories */}
            <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
                <h3 className="font-bold text-gray-800 p-4 bg-gray-50 border-b">Ürün Grupları</h3>
                <ul className="divide-y divide-gray-100">
                    {categories.map((cat, idx) => (
                        <li key={idx}>
                            <button 
                                onClick={cat.onClick}
                                className={`w-full text-left px-4 py-3 text-sm flex justify-between items-center hover:bg-gray-50 transition-colors ${cat.active ? 'font-bold text-blue-600 bg-blue-50' : 'text-gray-600'}`}
                            >
                                <span>{cat.name}</span>
                                {cat.count !== undefined && <span className="text-gray-400 text-xs">({cat.count})</span>}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default SidebarFilter;
